<template>
  <div class="dynamic">
    <div class="title-wrap">
      <div class="title">{{ info.title }}</div>
      <div class="type">
        {{ info.type | typeFilter}}
      </div>
    </div>
    <div class="content">
      <span>{{ info.content }}</span>
    </div>
    <div class="time">
      <span>{{ info.nodeDate | timeFilter}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'dynamic-com',
  data () {
    return {
    }
  },
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  filters: {
    timeFilter (val) {
      if (!val) return
      const timeArr = val.substring(0, 10).split('-')
      let str =  `${timeArr[0]}年${timeArr[1]}月${timeArr[2]}日`
      return str
    },
    typeFilter (val) {
      let arr = [ { label: "开盘速递", value: 1}, {label: "销售动态", value: 2}, {label: "活动快讯", value: 3} ]
      return (arr.find(item => item.value === val) && arr.find(item => item.value === val).label) || ''
    }
  },
}
</script>
<style lang="scss" scoped>
.dynamic{
  .title-wrap{
    div{
      display: inline-block;
    }
    .title {
      @include font16(500, #3E3E3E);
    }
    .type{
      @include font12(400, #BDA26C);
      padding: 0 5px;
      background: #FFF0D3;
      margin-left: 4px;
    }
  }
  .content{
    @include font14(400, #333333);
    margin-top: 12px;
    width: 100%;
    // height: 80px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .time{
    @include font12(400, #9399A5);
    margin: 2.5px 0 16px;
    padding-bottom: 60px
  }
}
</style>
